export const SoundCloudEmbed = ({ url }) => {
  const iframeSrc = url.includes("w.soundcloud.com/player")
    ? url
    : `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%23FF6B35&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=false`;
  return (
    <div className="mt-3 rounded-2xl overflow-hidden w-full max-w-full">
      <iframe
        width="100%"
        height="166"
        scrolling="no"
        frameBorder="no"
        allow="autoplay"
        src={iframeSrc}
        title="SoundCloud"
        style={{ maxWidth: "100%" }}
      />
    </div>
  );
};
